/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UploadProgressComponent} from './upload-progress.component';
import {WarningsModule} from '../warnings/warnings.module';
import {FilePreviewModule} from '../file-preview/file-preview.module';
import {TooltipModule} from '../tooltip/tooltip.module';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {GenericOverlayModule} from '../generic-overlay/generic-overlay.module';


@NgModule({
    declarations: [UploadProgressComponent],
    imports: [
        CommonModule,
        WarningsModule,
        FilePreviewModule,
        TooltipModule,
        LoadingSpinnerModule,
        GenericOverlayModule
    ],
    exports: [UploadProgressComponent]
})

export class UploadProgressModule {
}
